import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadUser } from "../../actions/userActions";

import EditResume from "../Student_New/EditResume";
import PreviewCandidate from "../EmployerNew/Preview";

function ProfileRouter() {
  const { CandidateId } = useParams();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    if (localStorage.getItem("token") && !user) {
      dispatch(loadUser());
    }
  }, [dispatch, user]);

  const loginUserId = user?._id;
  if (loginUserId && loginUserId === CandidateId) {
    return <EditResume />;
  }
  return <PreviewCandidate />;
}

export default ProfileRouter;